import React, { useState,useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import { useSelector } from "react-redux";
import UnallocatedChecksModal from "../Common/UnallocatedChecksModal"
import {getDateByName, convertDateFormate} from "../../helpers/api_helper";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import { DISCOUNT, NEWDISCOUNT, POST_KPI_DASHBOARD, POST_MENU_OPTIMIZATION } from "../../helpers/data_helper";
import { toast, ToastContainer } from "react-toastify";

const BreadCrumb = ({
  title,
  pageTitle,
  handleRefresh,
  showAlert,
  activeDate,
  customDate,
  leftFilter = activeDate,
  rightFilter = { value: "ThisMonth" },
  comparisonDate = [],
  mealPeriod = 0,
  refresh = false,
  course,
  server_id = 0,
  server_id_for_performance_trends,
  discount_id,
  trend_period,
  metric = "",
  selectedPageItems,
  selectedPageRatio
}) => {
  const [unallocatedChecksModal,setUnallocatedChecksModal]=useState(false);
  const [checklist,setCheckList]=useState([]);
  const [totalChecks,setTotalChecks]=useState(0);
  const [aiInsights, setAiInsights] = useState([]);
  const [showSummary, setShowSummary] = useState(false);
  const [loadingSummary, setLoadingSummary] = useState(false);

  const { currentOutlet, userInfo } = useSelector((state) => ({
    currentOutlet: state.UserOutletGroup?.currentOutlet,
    userInfo: state.UserOutletGroup?.userInfo,
  }));

  // const hiddenPages = [
  //   "Flash",
  //   "Table Seat Optimization",
  //   "Menu Design",
  //   "Upselling",
  //   "ROI Calculations",
  //   "Group Management",
  //   "Event Management",
  //   "Server Performance Coaching",
  //   "Menu Management",
  //   "Flash Cards",
  //   "Training Videos",
  //   "Check Listings",
  //   "Reports",
  //   "Supports",
  // ];
  const visiblePages = [
    "Playground",
    "Capture Ratio",
    "Forecast",
    "Menu Optimization",
    "Server Performance",
    "Discount & Promotion",
  ];

  const pageName = title.toLowerCase().replace(/\s+/g, "-").trim();

  const getDateFilter = (filter, customDates) =>
    filter?.value === "Custom"
      ? {
          from: convertDateFormate(customDates?.[0]),
          to: convertDateFormate(customDates?.[1]),
        }
      : getDateByName(filter?.value || "Yesterday");

  const pageSectionBuilders = {
    playground: () => [
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.widget_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        rightFilter:
          rightFilter?.value === "Custom"
            ? {
                from: convertDateFormate(comparisonDate?.[0]),
                to: convertDateFormate(comparisonDate?.[1]),
              }
            : getDateByName(rightFilter?.value || "ThisMonth"),
        mealPeriod,
        recalculate: refresh,
      },
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.server_performance_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        server_id: 0,
        mealPeriod,
        page: 0,
        recalculate: refresh,
      },
      {
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.selling_item_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        course,
        page: 0,
        recalculate: refresh,
        limit: 50,
      },
    ],

    "capture-ratio": () => [
      {
        serviceName: "pms_data",
        op: "pms_widget",
        dateFilter: getDateFilter(leftFilter, customDate),
      },
      {
        serviceName: "pms_data",
        op: "pms_weekly_capture_ratio_calendar",
        dateFilter: getDateFilter(leftFilter, customDate),
      },
      {
        serviceName: "pms_data",
        op: "pms_weekly_performance_analysis",
        dateFilter: getDateFilter(leftFilter, customDate),
      },
    ],

    forecast: () => [
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.forecast_op,
        // dateFilter: getDateFilter(leftFilter, customDate),
        dateFilter: {
          from: convertDateFormate(new Date()),
          to: convertDateFormate(
            new Date(new Date().setDate(new Date().getDate() + 7)),
          ),
        },
        mealPeriod,
      },
    ],

    "menu-optimization": () => [
      {
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.menu_food_bev_dashboard_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        course,
      },
      {
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.item_graph_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        course,
      },
      {
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.food_tribes_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        course,
      },
      {
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.performance_analysis,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        course,
      },
      {
        serviceName: POST_MENU_OPTIMIZATION.serviceName,
        op: POST_MENU_OPTIMIZATION.selling_item_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        course,
      },
    ],

    "server-performance": () => [
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.fetch_items_per_cover_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        page: selectedPageItems,
      },
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.fetch_food_to_beverage_ratio_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        page: selectedPageRatio,
      },
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.server_top_bottom_performace_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        server_id,
      },
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.server_performance_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        server_id,
      },
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: "kpi_server_course_performance",
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
      },
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: "kpi_server_course_performance_trends",
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        server_id: server_id_for_performance_trends,
        course,
        metric
      },
      {
        serviceName: POST_KPI_DASHBOARD.serviceName,
        op: POST_KPI_DASHBOARD.server_performance_contribution_mix_op,
        dateFilter: getDateFilter(leftFilter, customDate),
        mealPeriod,
        server_id,
      },
    ],

    "discount-&-promotion": () => [
      {
        serviceName: NEWDISCOUNT.serviceName,
        op: NEWDISCOUNT.op_discount_dashboard_widget,
        dateFilter: {from: leftFilter?.from_date, to: leftFilter?.to_date},
        mealPeriod,
        server_id,
        discount_id,
      },
      {
        serviceName: NEWDISCOUNT.serviceName,
        op: NEWDISCOUNT.op_discount_dashboard_server,
        dateFilter: {from: leftFilter?.from_date, to: leftFilter?.to_date},
        mealPeriod,
        server_id,
        discount_id,
      },
      {
        serviceName: NEWDISCOUNT.serviceName,
        op: NEWDISCOUNT.op_daily_discount_distribution,
        dateFilter: {from: leftFilter?.from_date, to: leftFilter?.to_date},
        mealPeriod,
        server_id,
        discount_id,
      },
      {
        serviceName: NEWDISCOUNT.serviceName,
        op: "day_of_week_discount_performance",
        dateFilter: {from: leftFilter?.from_date, to: leftFilter?.to_date},
        mealPeriod,
        server_id,
        discount_id,
        trend_period,
      },
      {
        serviceName: DISCOUNT.serviceName,
        op: DISCOUNT.op_discount_performance,
        dateFilter: {from: leftFilter?.from_date, to: leftFilter?.to_date},
        mealPeriod,
        server_id,
        discount_id,
      },
    ],
  };

  const sections = pageSectionBuilders[pageName]?.() || [];

  const getUnmappedChecks = useCallback(async () => {
    const reponse = await postDataAPI({
        dateFilter: activeDate.value==='Custom'?{from:convertDateFormate(customDate[0]),to:convertDateFormate(customDate[1])}:getDateByName(activeDate.value),
        serviceName: 'service_period_data',
        op: 'get_unmapped_sp_id'
    });
    setCheckList(reponse.data.list)
    setTotalChecks(reponse.data.total_rows)
  }, [activeDate, customDate]);

  useEffect(()=>{
    if(showAlert){
      getUnmappedChecks();
    }
  },[showAlert, getUnmappedChecks])

  const handleAISummary = async () => {
    if (!pageName || sections.length === 0) {
      return;
    }

    try {
      setLoadingSummary(true);

      const response = await postDataAPI({
        op: "get_ai_dashboard_insights",
        serviceName: "ai_dashboard",
        app_user_id: userInfo?.user_id,
        selectedOutletID: currentOutlet?.id,
        page_name: pageName,
        sections,
      });

      if (response.status === "ok") {
        setAiInsights(
          response.data?.top_insights || ["No insights available."],
        );
        setShowSummary(true);
      } else {
        toast.error(
          response.message || "Failed to generate AI insights. Please try again.",
          {
            position: "top-right",
            hideProgressBar: false,
            progress: undefined,
            toastId: "",
          },
        );
      }
    } catch (error) {
      console.error("AI summary request failed", error);
      // toast.error(
      //   error.message || "Failed to generate AI insights. Please try again.",
      //   {
      //     position: "top-right",
      //     hideProgressBar: false,
      //     progress: undefined,
      //     toastId: "",
      //   },
      // );
    } finally {
      setLoadingSummary(false);
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <h4 className="mb-sm-0 pe-3">{title}</h4>
              {/* <button
                    onClick={handleRefresh}
                    type="button"
                    className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle"
                >                                       
                    <i className='bx bx-refresh fs-2'></i>
                </button> */}
            </div>
            <div className="page-title-right d-flex align-items-center">
              {visiblePages.includes(title) && (
                <Button
                  color="none"
                  className="ai-summary-btn me-3 d-flex align-items-center"
                  onClick={handleAISummary}
                  disabled={loadingSummary}
                >
                  {loadingSummary ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      />
                      AI is analyzing your report...
                    </>
                  ) : (
                    <>
                      <i className="bx bx-bot fs-4 me-2"></i>
                      Get AI-Generated Summary
                    </>
                  )}
                </Button>
              )}

              {showAlert && (
                <button
                  onClick={() => setUnallocatedChecksModal(true)}
                  type="button"
                  className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle me-5"
                >
                  <i className="bx bx-bell fs-2"></i>
                  <span className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">
                    {totalChecks}
                  </span>
                </button>
              )}
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">{pageTitle}</Link>
                </li>
                <li className="breadcrumb-item active">{title}</li>
              </ol>
            </div>
          </div>
        </Col>
      </Row>
      {showSummary && (
        <Row className="mb-3">
          <Col xs={12}>
            <div className="ai-summary-card">
              <div className="d-flex align-items-center mb-3">
                <i className="bx bx-bot fs-4 me-2 text-primary"></i>
                <h6 className="mb-0">AI Generated Insights</h6>
              </div>

              <ul className="ai-insights-list mb-0">
                {aiInsights.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </div>
          </Col>
        </Row>
      )}

      {unallocatedChecksModal && (
        <UnallocatedChecksModal
          getUnmappedChecks={getUnmappedChecks}
          activeDate={activeDate}
          customDate={customDate}
          checklist={checklist}
          unallocatedChecksModal={unallocatedChecksModal}
          setUnallocatedChecksModal={setUnallocatedChecksModal}
        />
      )}

      <ToastContainer />
    </React.Fragment>
  );
};

export default BreadCrumb;
